<template>
  <div class="mobile-wrapper">
    <div
      :style="BackgroundColor"
      class="justify-content-center so-register text-center"
    >
      <div
        v-if="Logo && Logo.length"
        class="big-logo"
        style="margin-top: -1rem"
      >
        <img :src="Logo" @error="imgHttpError" />
      </div>

      <h2 v-else class="w-100 text-center mt-5 mb-3 text-white">
        {{ currentStoreDoc.Name }}
      </h2>

      <div class="step-title">
        {{ getSignupHeader }}
      </div>
      <div class="step-desc">{{ getSignupDescription}}</div>
      <div
          class="col-md-9 bg-white py-4 form-container text-left shadow-lg"
          style="border-radius: 10px"
      >

        <!--    Enter Otp Form Start    -->
        <form
            v-if="showConfirmation"
            ref="register"
            class="otp-form pt-2 pb-4 d-flex flex-wrap justify-content-center mb-5 bg-white rounded"
        >
          <div class="w-75  d-flex flex-row align-items-center justify-content-start" @click="step = 1">
             <span class="material-icons md-36"
             >keyboard_arrow_left</span
             >
            <span>{{ $t("message.back") }}</span>
          </div>
          <div class="w-75 mt-3 mb-4 d-flex justify-content-center text-center">
            <h4>
              {{ $t("message.enterCodeSentTo") }}
              {{ this.countryCode + this.mobile }}
            </h4>

          </div>

          <div class="w-full">
            <OtpInput
                ref="otpInput"
                :is-input-num="true"
                :num-inputs="6"
                :should-auto-focus="true"
                autocomplete="one-time-code"
                input-classes="otp-input"
                separator="-"
                @on-complete="verifyOtpAndRegisterSoUser"
            />
          </div>

          <div
              class="w-85 mt-4 d-flex align-items-center justify-content-between"
          >
            <span class="font-13">{{ $t("message.smsResendDescription") }}</span>
            <button
                :disabled="!enableResendBtn || loading"
                :style="mobileStyles.LinkColorTxt"
                class="btn btn-link resend-btn font-13"
                type="button"
                @click="resendSms"
            >
              {{ $t("message.smsResendButton") }}
              <span v-show="!enableResendBtn && !loading" class="font-13"
              >({{ resendWait }})</span
              >
            </button>
          </div>

          <div class="w-75 mt-3">
            <button
                :disabled="loading"
                :style="mobileStyles.btn"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
                type="button"
                @click="verifyOtpAndRegisterSoUser(verificationCode)"
            >
              {{ $t("message.confirm") }}
              <span v-show="loading">
                  <i class="spin ml-4"/>
                </span>
            </button>
          </div>

          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>

        <form
            v-else
            ref="registerSoUserfrm"
            class="pt-2 pb-4 d-flex flex-wrap justify-content-center p-3 mb-5 bg-white rounded"
            @submit.prevent="goToVerifyCode"
        >


          <div class="form-group">
            <label for="Mobile"
            >{{ $t("message.mobile") }}
              <span class="required-logo">*</span></label
            >
            <b-input-group>
              <template #prepend>
                <VueCountryCode
                    @onSelect="selectCountryCode"
                    :preferredCountries="['au', 'us', 'gb']"
                />

              </template>

              <b-form-input v-validate="{
                required: true,
                min: 8,
                regex: this.getRegex(),
                max: this.getMax(),
              }"
                    id="Mobile"
                    v-model="mobile"
                    name="mobile"
                    type="text"
                    class="form-control mobile">

              </b-form-input>


              <div class="invalid-feedback">
                {{ OOErrors.first("mobile") | inputNameLocale("mobile") }}
              </div>
            </b-input-group>

          </div>

          <div class="form-group">
            <label for="Name"
              >{{ $t("message.name") }}
              <span class="required-logo">*</span></label
            >
            <input
              v-validate="'min:2'"
              id="Name"
              v-model="fullName"
              name="name"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("firstName") | inputNameLocale("firstName") }}
            </div>
          </div>
          <div class="form-group">
            <label for="Email"
              >{{ $t("message.emailAddress") }}
              <span class="required-logo">*</span></label
            >
            <input
              id="Email"
              v-model="email"
              v-validate="'required|email'"
              name="email"
              type="email"
              class="form-control"
              aria-describedby="emailHelp"
              ref="emailAddress"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("email") | inputNameLocale("email") }}
            </div>
          </div>
          <div class="form-group" v-show="enableDob">
            <label for="BirthDate">
              {{ $t("message.birthDate") }}
            </label>
            <date-pick
              id="BirthDate"
              name="birthDate"
              v-model="birthDate"
              :format="'DD/MM/YYYY'"
              :inputAttributes="{
                placeholder: 'DD/MM/YYYY',
                class: ['form-control', bdstatus],
              }"
              @input="isValidDate($event)"
              :parseDate="parseDate"
              :startPeriod="{month: 0, year: 1990}"
            ></date-pick>
            <span
              v-if="birthDatestatus == 2"
              class="invalid-feedback"
              style="display: block"
              >{{
                birthDatestatus == 1
                  ? $t("message.birthDateRequire")
                  : "The Date of Birth should be DD/MM/YYYY format"
              }}</span
            >
            <div class="invalid-feedback">
              {{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}
            </div>
          </div>
          <div class="form-group" v-show="enableGender" >
            <label for="Gender">{{ $t("message.gender") }}</label>
            <vselect
              :options="genderOptions"
              :searchable="false"
              :clearable="false"
              v-model="gender"
              label="text"
              value="id"
            >
              <template slot="option" slot-scope="option">
                {{ option.text }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.text }}
              </template>
            </vselect>
          </div>
          <div class="form-group">
            <label for="Postcode">{{ $t("message.postcode") }}</label>
            <input
              v-validate="'numeric|min:4|max:4'"
              id="Postcode"
              v-model="postcode"
              name="postcode"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
            </div>
          </div>
          <div class="form-group" v-if="enablePreferredStore">
            <label for="PreferredStore">{{
              $t("message.preferredStore")
            }}</label>
            <vselect
              :options="preferredStoreOptions"
              :searchable="false"
              :clearable="false"
              v-model="preferredStore"
              label="Name"
              value="ID"
            >
              <template slot="option" slot-scope="option">
                {{ option.Name }}
              </template>
              <template slot="selected-option" slot-scope="option">
                {{ option.Name }}
              </template>
            </vselect>
          </div>

          <div class="form-group mt-4 justify-content-left d-flex">
            <Checkbox :label="''" v-model="agree" :IsRadio="false"></Checkbox>
            <p class="agree-container">
              {{ $t("message.agreeSoRegister") + currentStoreDoc.Name }}
            </p>
          </div>

          <div class="form-group mt-3">
            <button
              :disabled="loading || !agree"
              :style="mobileStyles.btn"
              type="submit"
              style="border-radius: 8px"
              class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-around align-items-center font-16"
            >
              <span v-show="!loading" class="ml-3"></span>
              <span class="ml-5">{{ $t("message.joinMembership") }}</span>
              <span v-show="!loading" class="material-icons md-36 pl-5">keyboard_arrow_right</span>
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div
            class="w-75 mt-4 justify-content-center"
            @click.prevent="showModal = true"
          >
            <p
              v-html="$t('message.termsOfUsePrivacyStatement')"
              style="font-size: 0.5875rem; line-height: 1.4; text-align: center"
            ></p>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
      </div>
      <div class="logo-powered-by">Powered by</div>
      <div class="abacus-logo"></div>
    </div>
    <progressindicator
      v-if="showProgress"
      style="opacity: 0.4"
    ></progressindicator>
    <termsAndConditionsModal v-if="showModal" @close-modal="closeModal" />
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/register.js";
import { mapGetters, mapActions } from "vuex";
import { wcconfig } from "../../../wcConfig";
import vselect from "vue-select";
import DatePick from "vue-date-pick";
import progressindicator from "../progressindicator";
import Checkbox from "../shared/checkbox";
import { getStoreByHqID } from "../../api/services/storeService.js";
import termsAndConditionsModal from "../shop/partials/termsAndConditionsModal.vue";
import OtpInput from "@bachdgvn/vue-otp-input";
import VueCountryCode from "vue-country-code";

export default {
  components: {
    vselect,
    DatePick,
    progressindicator,
    Checkbox,
    termsAndConditionsModal,
    OtpInput,
    VueCountryCode
  },
  props: {
    storeid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      verificationCode: '',

      showmeesage: false,
      success: true,
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      mobile: "",
      postcode: "",
      birthDate: "",
      loading: false,
      showProgress: false,
      address: "",
      error: "",
      logoUrl: "",
      birthDatestatus: 0,
      genderOptions: [
        { id: true, text: "Male" },
        { id: false, text: "Female" },
        { id: null, text: "Unspecified" },
      ],
      gender: null,
      preferredStoreOptions: [],
      preferredStore: null,
      agree: false,
      showModal: false,
      // step 1 displays form
      // step 2 displays OTP input for phone number auth
      step: 1,
      appVerifier: "",
      otp: "",
      countryCode: "+61",
      resendWait: 30, //seconds
      showSuccess: function (msg) {
        this.makeToast("Success", msg, "success");
      },
      showError: function (msg) {
        this.makeToast("Internal Error", msg, "danger");
      },
    };
  },
  created() {
    this.logoUrl = wcconfig.assets.abacus;
  },
  mounted() {
    const self = this;
    this.showProgress = true;
    this.setStore(this.storeid);
    
    this.initStoreWallet(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
        self.setStoreLoaded();
      },
    });
    this.initReCaptcha();
  },
  computed: {
    ...mapGetters(["mobileStyles", "viewConfig", "currentStoreDoc", "getStoreWalletDoc", "getStoreColor"]),
    showConfirmation() {
      return this.step === 2
    },
    enableResendBtn() {
      return this.resendWait === 0;
    },
    bdstatus() {
      return this.birthDatestatus == 2 ? "invaliddatetime" : "";
    },
    Logo() {
      if (this.currentStoreDoc && this.currentStoreDoc.Logo) {
        return this.currentStoreDoc.Logo;
      }
      if (
        this.currentStoreDoc &&
        this.currentStoreDoc.ThemeSettings &&
        this.currentStoreDoc.ThemeSettings.BackgroundPhotos
      ) {
        return this.currentStoreDoc.ThemeSettings.BackgroundPhotos.CommonLogo;
      }
      return "";
    },
    BackgroundColor() {
      let styles = [];
      let colour = this.getStoreColor;

      if(this.storeThemeConfiguration && this.storeThemeConfiguration.CardBackground){
        colour = this.storeThemeConfiguration.CardBackground
      }
      styles.push({ "background-color": `${colour}` });
      return styles;
    },
    fullName: {
      get() {
        if (!this.lastName.length) {
          return this.firstName;
        }
        return this.firstName + " " + this.lastName;
      },
      set(val) {
        if (!val) return;
        const [firstName, ...lastName] = val.split(" ").filter(Boolean);
        this.firstName = firstName;
        this.lastName = lastName.join(" ");
      },
    },
    storeGeneralConfiguration(){
      if(!this.getStoreWalletDoc || !this.getStoreWalletDoc.GeneralConfiguration){
        return null
      }

      return this.getStoreWalletDoc.GeneralConfiguration
    },
    storeThemeConfiguration(){
      if(!this.getStoreWalletDoc || !this.getStoreWalletDoc.ThemeConfiguration){
        return null
      }

      return this.getStoreWalletDoc.ThemeConfiguration
    },

    enableDob(){
      return this.storeGeneralConfiguration && this.storeGeneralConfiguration.EnableDob
    },

    enableGender(){
      return this.storeGeneralConfiguration && this.storeGeneralConfiguration.EnableGender
    },

    enablePreferredStore() {
      return (
        this.storeGeneralConfiguration &&
        this.storeGeneralConfiguration.EnablePreferredStore
      );
    },

    getSignupHeader(){
      if(!this.storeGeneralConfiguration) return this.$t("message.soRegisterLastStepMessage")
      return this.storeGeneralConfiguration.SignUpHeader || this.$t("message.soRegisterLastStepMessage")
    },
    getSignupDescription(){
      if(!this.storeGeneralConfiguration) return this.$t("message.soRegisterLastStepDesc")
      return this.storeGeneralConfiguration.SignUpText || this.$t("message.soRegisterLastStepDesc")
    }
  },
  methods: {
    closeDialog() {
      this.step = 1;
    },
    ...shared.methods,
    ...mapActions(["initStore", "initStoreWallet"]),
    makeToast(title, msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
    closeModal() {
      this.showModal = false;
    },
    parseDate(dateString) {
      var date = dateString.split("/");
      if (
        date[0] &&
        date[0].length > 0 &&
        date[1] &&
        date[1].length > 0 &&
        date[2] &&
        date[2].length == 4
      ) {
        return new Date(date[2], date[1] - 1, date[0]);
      } else {
        return undefined;
      }
    },
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    async goToVerifyCode() {
      await this.sendLoyaltyOtp();
    },

    selectCountryCode(value){
     this.countryCode = `+${value.dialCode}`;
    },

  },
  watch: {
    currentStoreDoc(newStore) {
      if (newStore.HQCompanyID != newStore.ID || newStore.IsHQ) {
        var that = this;
        that.showProgress = true;
        getStoreByHqID(newStore.HQCompanyID)
          .get()
          .then(function (snapshot) {
            that.showProgress = false;
            that.preferredStoreOptions = [];
            snapshot.docs.forEach(function (doc) {
              var item = doc.data();
              if (item.ID != newStore.HQCompanyID)
                that.preferredStoreOptions.push(item);
            });
          })
          .catch(() => {
            that.showProgress = false;
          });
      } else {
        this.showProgress = false;
      }
    },
  },
};
</script>
<style lang="scss">
.otp-form .otp-input {
  width: 2rem !important;
  height: 2rem !important;
  padding: 5px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}

.vdpComponent {
  display: block;
}
.required-logo {
  color: red;
}
label {
  color: black;
}
input {
  border-radius: 8px;
}
input.mobile {
  border-top-left-radius: 0!important;
  border-bottom-left-radius: 0!important;
}
.centered {
  position: fixed;
  top: 13%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.success {
  background-color: #22bb33;
  border-radius: 10px;
  padding: 15px 15px;
}
.error {
  background-color: #bb2124;
  border-radius: 15px;
  padding: 5px 10px;
}
.messagetext {
  margin-bottom: 5px !important;
  color: white;
}
.messagebtn {
  text-align: right;
  margin-bottom: 5px !important;
  color: white;
  cursor: pointer;
}

.oo-module {
  .mobile-wrapper {
    .so-register {
      background: #fff 0% 0% no-repeat padding-box;
      opacity: 0.95;
      min-height: 100vh;
      .step-title {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 50px;
        margin-left: auto;
        margin-right: auto;
        width: 80vw;
      }

      .step-desc {
        width: 90vw;
        font-size: 16px;
        color: #ffffff;
        margin-top: 30px;
        margin-left: auto;
        margin-right: auto;
      }
      .form-container {
        padding: 20px 0;
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        background-color: #ffffff;
        margin-top: 10%;
        margin-bottom: 3%;

        .form-group {
          width: 90%;
          margin-bottom: 0.2rem;
          .checkbox-label {
            left: 0;
          }
          span.checkbox-checkmark {
            left: 0px !important;
          }
          p.agree-container {
            position: relative;
            left: -20px;
            text-align: left;
            font-size: 0.6875rem;
            line-height: 1.4;
            text-align: left;
            padding-left: 10px;
            padding-top: 1px;
          }
          label {
            font-size: 0.8rem;
            margin-bottom: 0.1rem;
          }

          .form-control,
          .dropdown-toggle {
            border-radius: 8px;
          }
        }
      }

      .big-logo {
        margin-top: 0;
        padding-top: 10%;
        margin-left: 0;
        max-height: 93px;
        max-width: 158px;
        margin-left: auto;
        margin-right: auto;
        img {
          max-height: 93px;
          max-width: 100%;
        }
      }

      .abacus-logo {
        margin-left: auto;
        margin-right: auto;
        height: 26px;
        width: 100px;
        background: transparent url("./../../assets/abacus-logo-white.png") 0%
          0% no-repeat padding-box;
        opacity: 1;
        background-size: contain;
        padding-bottom: 50px;
      }
      .logo-powered-by {
        margin-left: auto;
        margin-right: auto;
        width: 82px;
        font-size: 10px;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }
}

.b-toast-danger.b-toast-solid,
.b-toast-success.b-toast-solid {
  .toast {
    flex-basis: 350px;
    font-size: 0.875rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
    .toast-header {
      padding: 0.45rem 0.85rem;
    }
    .toast-body {
      padding: 0.75rem;
    }
  }
}
</style>
